import { render, staticRenderFns } from "./FooterLogin.vue?vue&type=template&id=a0188898&scoped=true"
import script from "./FooterLogin.vue?vue&type=script&lang=js"
export * from "./FooterLogin.vue?vue&type=script&lang=js"
import style0 from "./FooterLogin.vue?vue&type=style&index=0&id=a0188898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0188898",
  null
  
)

export default component.exports